var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Spinner as ChakraLoader, useColorModeValue } from "@chakra-ui/react";
import { Size } from "../../core/constants";
import { pick } from "../../core/utils";
export const LoaderSize = pick(Size, ["xs", "sm", "md", "lg", "xl"]);
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result.
 */
export const Loader = forwardRef((_a, ref) => {
    var { colorScheme, variantColor, speed = "0.65s" } = _a, rest = __rest(_a, ["colorScheme", "variantColor", "speed"]);
    const scheme = colorScheme || variantColor;
    const emptyColor = useColorModeValue("gray.300", "gray.600");
    return (React.createElement(ChakraLoader, Object.assign({}, rest, { ref: ref, speed: speed, color: scheme && `${scheme}.500`, emptyColor: emptyColor, thickness: "4px" })));
});
Loader.displayName = "Loader";
export default Loader;
//# sourceMappingURL=Loader.js.map